export function isFunction(obj) {
  return typeof obj === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/utils/index.js
// module id = 595
// module chunks = 2